<template>
  <v-app id="app">
    <div id="background"></div>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",
};
</script>


<style scoped>

@font-face {
    font-family: myFirstFont;
    src: url('./assets/DelitschAntiqua.ttf');
}

#app {
  font-family: myFirstFont;
}


#background {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-image: url("https://firebasestorage.googleapis.com/v0/b/tibiawallstreet.appspot.com/o/front%2FYalaharIsland1920x1200.jpg?alt=media&token=9f6b7196-ac84-497b-9d18-979b226c22d7");
  background-position: center;
  background-size: auto 120%;
  opacity: .8;
  background-repeat: no-repeat;
}
</style>